var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M87.5 6.25a6.25 6.25 0 0 1 6.25 6.25v75a6.25 6.25 0 0 1-6.25 6.25h-75a6.25 6.25 0 0 1-6.25-6.25v-75a6.25 6.25 0 0 1 6.25-6.25zM12.5 0A12.5 12.5 0 0 0 0 12.5v75A12.5 12.5 0 0 0 12.5 100h75A12.5 12.5 0 0 0 100 87.5v-75A12.5 12.5 0 0 0 87.5 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M55.813 41.175 41.5 42.969l-.513 2.375 2.813.518c1.838.438 2.2 1.1 1.8 2.932l-4.613 21.675c-1.212 5.606.657 8.244 5.05 8.244 3.407 0 7.363-1.575 9.157-3.738l.55-2.6c-1.25 1.1-3.075 1.537-4.288 1.537-1.719 0-2.344-1.206-1.9-3.33zm.437-13.05a6.25 6.25 0 1 1-12.5 0 6.25 6.25 0 0 1 12.5 0"
  })));
};
export default SvgInfo;